<template>
    <div>
        <b-modal id="help-modal" centered no-close-on-backdrop :header-class="'align-items-center'" hide-footer
            no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('help.title') }}
                </h5>
                <svg @click="close()" class="cursor-pointer" width="13" height="13" viewBox="0 0 13 13" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.5"
                        d="M7.56134 6.46422L12.8263 1.19922C12.9447 1.06106 13.0065 0.883335 12.9995 0.701569C12.9924 0.519803 12.9171 0.34738 12.7885 0.218757C12.6598 0.0901327 12.4874 0.0147812 12.3057 0.00776032C12.1239 0.000739488 11.9462 0.0625664 11.808 0.180885L6.543 5.44589L1.278 0.173663C1.13984 0.055344 0.96212 -0.00648221 0.780354 0.000538623C0.598588 0.00755946 0.426166 0.0829103 0.297542 0.211534C0.168918 0.340158 0.0935665 0.512581 0.0865456 0.694347C0.0795248 0.876113 0.141352 1.05383 0.259671 1.192L5.52467 6.46422L0.252448 11.7292C0.176845 11.794 0.115441 11.8736 0.0720912 11.9632C0.028741 12.0528 0.00438004 12.1504 0.000538185 12.2499C-0.00330367 12.3494 0.0134562 12.4486 0.0497656 12.5412C0.086075 12.6339 0.14115 12.7181 0.211534 12.7885C0.281918 12.8589 0.366091 12.9139 0.458771 12.9502C0.55145 12.9865 0.650634 13.0033 0.750098 12.9995C0.849562 12.9956 0.947158 12.9713 1.03676 12.9279C1.12636 12.8846 1.20604 12.8232 1.27078 12.7476L6.543 7.48255L11.808 12.7476C11.9462 12.8659 12.1239 12.9277 12.3057 12.9207C12.4874 12.9137 12.6598 12.8383 12.7885 12.7097C12.9171 12.5811 12.9924 12.4086 12.9995 12.2269C13.0065 12.0451 12.9447 11.8674 12.8263 11.7292L7.56134 6.46422Z"
                        fill="#85909E" />
                </svg>


            </template>
            <div class="d-block d-sm-flex align-items-center justify-content-between flex-wrap gap-3">
                <a class="help-section mx-auto mx-sm-0 mb-2 mb-sm-0" href="https://www.digitalpermitbook.com/help"
                    target="_blank" @click="$bvModal.hide('help-modal')">
                    <div class="text-center mb-3">
                        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.6">
                                <path
                                    d="M22.5 45C10.0929 45 0 34.9072 0 22.5C0 10.0929 10.0929 0 22.5 0C34.9072 0 45 10.0929 45 22.5C45 34.9072 34.9072 45 22.5 45ZM22.5 3.21428C11.8607 3.21428 3.21428 11.8607 3.21428 22.5C3.21428 33.1393 11.8607 41.7857 22.5 41.7857C33.1393 41.7857 41.7857 33.1393 41.7857 22.5C41.7857 11.8607 33.1393 3.21428 22.5 3.21428Z"
                                    fill="black" />
                                <path
                                    d="M22.5002 11.25C18.9324 11.25 16.0717 14.1107 16.0717 17.6786H19.2859C19.2859 15.9107 20.7324 14.4643 22.5002 14.4643C24.2681 14.4643 25.7146 15.9107 25.7146 17.6786C25.7146 20.8928 20.8931 20.5072 20.8931 25.7143H24.1074C24.1074 22.1143 28.9289 21.6965 28.9289 17.6786C28.9289 14.1107 26.0681 11.25 22.5002 11.25Z"
                                    fill="black" />
                                <path
                                    d="M22.5 34.1321C23.6006 34.1321 24.4928 33.2398 24.4928 32.1393C24.4928 31.0386 23.6006 30.1464 22.5 30.1464C21.3993 30.1464 20.5071 31.0386 20.5071 32.1393C20.5071 33.2398 21.3993 34.1321 22.5 34.1321Z"
                                    fill="black" />
                                <path
                                    d="M17.6788 19.2877C18.5664 19.2877 19.2859 18.5682 19.2859 17.6806C19.2859 16.793 18.5664 16.0734 17.6788 16.0734C16.7912 16.0734 16.0717 16.793 16.0717 17.6806C16.0717 18.5682 16.7912 19.2877 17.6788 19.2877Z"
                                    fill="black" />
                                <path
                                    d="M22.5 27.3209C23.3876 27.3209 24.1072 26.6013 24.1072 25.7137C24.1072 24.8262 23.3876 24.1067 22.5 24.1067C21.6124 24.1067 20.8929 24.8262 20.8929 25.7137C20.8929 26.6013 21.6124 27.3209 22.5 27.3209Z"
                                    fill="black" />
                            </g>
                        </svg>
                    </div>
                    <p class="text-center mb-0">{{ $t('help.needHelp') }}</p>
                </a>
                <a class="help-section position-relative mx-auto mx-sm-0 mb-2 mb-sm-0"
                    href="https://www.digitalpermitbook.com/changelog" target="_blank" @click="setUserAppVersion">
                    <svg width="25" height="25" v-if="user && appVersion && user.version !== appVersion"
                        class="update-notification-dot-2" viewBox="0 0 15 15" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.5" cy="7.5" r="6.5" fill="#FF0000" stroke="white" stroke-width="2" />
                    </svg>

                    <div class="text-center mb-3">
                        <svg width="45" height="40" viewBox="0 0 45 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.6"
                                d="M3.825 15.0494C3.825 17.2244 4.191 19.3057 4.923 21.2932C5.655 23.2807 6.69525 25.1182 8.04375 26.8057C8.38125 27.2182 8.55 27.6869 8.55 28.2119C8.55 28.7369 8.3625 29.1869 7.9875 29.5619C7.6125 29.9369 7.1535 30.1154 6.6105 30.0974C6.0675 30.0794 5.6265 29.8634 5.2875 29.4494C3.6 27.4244 2.29725 25.1842 1.37925 22.7287C0.461253 20.2732 0.00150366 17.7134 3.65854e-06 15.0494C-0.00149634 12.3854 0.458253 9.82644 1.37925 7.37244C2.30025 4.91844 3.603 2.67744 5.2875 0.64944C5.625 0.23694 6.066 0.0209403 6.6105 0.00144034C7.155 -0.0180597 7.614 0.16044 7.9875 0.53694C8.361 0.91344 8.5485 1.36344 8.55 1.88694C8.5515 2.41044 8.38275 2.87919 8.04375 3.29319C6.69375 4.98069 5.6535 6.81819 4.923 8.80569C4.1925 10.7932 3.8265 12.8744 3.825 15.0494ZM11.25 15.0494C11.25 16.2494 11.4188 17.3932 11.7563 18.4807C12.0938 19.5682 12.6 20.5994 13.275 21.5744C13.575 21.9869 13.725 22.4654 13.725 23.0099C13.725 23.5544 13.5375 24.0134 13.1625 24.3869C12.7875 24.7604 12.3375 24.9479 11.8125 24.9494C11.2875 24.9509 10.875 24.7447 10.575 24.3307C9.5625 23.0182 8.78475 21.5654 8.24175 19.9724C7.69875 18.3794 7.4265 16.7384 7.425 15.0494C7.4235 13.3604 7.69575 11.7202 8.24175 10.1287C8.78775 8.53719 9.5655 7.08369 10.575 5.76819C10.875 5.35569 11.2875 5.14944 11.8125 5.14944C12.3375 5.14944 12.7875 5.33694 13.1625 5.71194C13.5375 6.08694 13.725 6.54669 13.725 7.09119C13.725 7.63569 13.575 8.11344 13.275 8.52444C12.6 9.49944 12.0938 10.5307 11.7563 11.6182C11.4188 12.7057 11.25 13.8494 11.25 15.0494ZM20.25 37.5494V20.2244C19.2375 19.7744 18.4215 19.0807 17.802 18.1432C17.1825 17.2057 16.8735 16.1744 16.875 15.0494C16.875 13.4744 17.4188 12.1432 18.5063 11.0557C19.5938 9.96819 20.925 9.42444 22.5 9.42444C24.075 9.42444 25.4062 9.96819 26.4937 11.0557C27.5812 12.1432 28.125 13.4744 28.125 15.0494C28.125 16.1744 27.8152 17.2057 27.1957 18.1432C26.5762 19.0807 25.761 19.7744 24.75 20.2244V37.5494C24.75 38.1869 24.534 38.7217 24.102 39.1537C23.67 39.5857 23.136 39.8009 22.5 39.7994C21.864 39.7979 21.33 39.5819 20.898 39.1514C20.466 38.7209 20.25 38.1869 20.25 37.5494ZM33.75 15.0494C33.75 13.8494 33.5812 12.7057 33.2437 11.6182C32.9062 10.5307 32.4 9.49944 31.725 8.52444C31.425 8.11194 31.275 7.63344 31.275 7.08894C31.275 6.54444 31.4625 6.08544 31.8375 5.71194C32.2125 5.33844 32.6625 5.15094 33.1875 5.14944C33.7125 5.14794 34.125 5.35419 34.425 5.76819C35.4375 7.08069 36.216 8.53419 36.7605 10.1287C37.305 11.7232 37.5765 13.3634 37.575 15.0494C37.5735 16.7354 37.3012 18.3764 36.7582 19.9724C36.2152 21.5684 35.4375 23.0212 34.425 24.3307C34.125 24.7432 33.7125 24.9494 33.1875 24.9494C32.6625 24.9494 32.2125 24.7619 31.8375 24.3869C31.4625 24.0119 31.275 23.5529 31.275 23.0099C31.275 22.4669 31.425 21.9884 31.725 21.5744C32.4 20.5994 32.9062 19.5682 33.2437 18.4807C33.5812 17.3932 33.75 16.2494 33.75 15.0494ZM41.175 15.0494C41.175 12.8744 40.809 10.7932 40.077 8.80569C39.345 6.81819 38.3047 4.98069 36.9562 3.29319C36.6187 2.88069 36.45 2.41194 36.45 1.88694C36.45 1.36194 36.6375 0.91194 37.0125 0.53694C37.3875 0.16194 37.8472 -0.0158098 38.3917 0.00369018C38.9362 0.0231902 39.3765 0.23844 39.7125 0.64944C41.4 2.67444 42.7035 4.91544 43.623 7.37244C44.5425 9.82944 45.0015 12.3884 45 15.0494C44.9985 17.7104 44.5395 20.2702 43.623 22.7287C42.7065 25.1872 41.403 27.4274 39.7125 29.4494C39.375 29.8619 38.9347 30.0779 38.3917 30.0974C37.8487 30.1169 37.389 29.9384 37.0125 29.5619C36.636 29.1854 36.4485 28.7354 36.45 28.2119C36.4515 27.6884 36.6202 27.2197 36.9562 26.8057C38.3062 25.1182 39.3472 23.2807 40.0792 21.2932C40.8112 19.3057 41.1765 17.2244 41.175 15.0494Z"
                                fill="black" />
                        </svg>

                    </div>
                    <p class="text-center mb-0">{{ $t('help.whatsNew') }}</p>
                </a>
                <div class="help-section mx-auto mx-sm-0 mb-2 mb-sm-0" @click="showSupportModal">
                    <div class="text-center mb-3">
                        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.6" fill-rule="evenodd" clip-rule="evenodd"
                                d="M44.5288 0.470345C44.7491 0.690449 44.9007 0.969834 44.9652 1.27452C45.0297 1.57921 45.0042 1.89606 44.8919 2.18655L28.8226 43.9668C28.7089 44.2625 28.5103 44.5179 28.2518 44.701C27.9933 44.8841 27.6865 44.9868 27.3699 44.996C27.0532 45.0053 26.7409 44.9208 26.4722 44.7531C26.2034 44.5854 25.9903 44.3421 25.8594 44.0536L19.1392 29.2698L29.0251 19.3807C29.4508 18.9238 29.6826 18.3194 29.6716 17.695C29.6606 17.0705 29.4076 16.4747 28.966 16.0331C28.5244 15.5915 27.9286 15.3385 27.3041 15.3275C26.6797 15.3165 26.0753 15.5483 25.6184 15.974L15.7293 25.8599L0.945514 19.1429C0.65616 19.0122 0.412002 18.7988 0.243856 18.5294C0.07571 18.2601 -0.00888796 17.947 0.00073914 17.6297C0.0103662 17.3123 0.113787 17.0049 0.297949 16.7463C0.48211 16.4877 0.738759 16.2894 1.0355 16.1765L42.8158 0.107178C43.1058 -0.00442512 43.422 -0.0295176 43.7261 0.0349405C44.0301 0.0993986 44.3089 0.250641 44.5288 0.470345Z"
                                fill="black" />
                        </svg>

                    </div>
                    <p class="text-center mb-0">{{ $t('help.support') }}</p>
                </div>
            </div>
        </b-modal>
        <Support v-if="supportModal" @close="supportModal = false"/>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import Support from "@/components/Help/Support.vue"
export default {
    name: "Help",
    components: { Support },
    data() {
        return {
            supportModal:false
        }
    },
    computed: {
        ...mapGetters(['user', 'appVersion'])
    },
    methods: {
        ...mapActions(['updateTeamMember', 'setAppVersion', 'setUserData']),
        async setUserAppVersion() {
            if (this.user.version !== this.appVersion) {
                try {
                    const currentTeamMember = this.user.team_member
                    delete currentTeamMember.profile_picture;
                    delete currentTeamMember.user.password;
                    let teamMemberData = {
                        ...currentTeamMember,
                        state: currentTeamMember.state.id
                            ? currentTeamMember.state.id
                            : 54,
                        license_state: currentTeamMember.license_state.id
                            ? currentTeamMember.license_state.id
                            : 54,
                        activate_date: currentTeamMember.activate_date
                            ? currentTeamMember.activate_date
                            : null,
                        clearing_house_date: currentTeamMember.clearing_house_date
                            ? currentTeamMember.clearing_house_date
                            : null,
                        dob: currentTeamMember.dob ? currentTeamMember.dob : null,
                        inactive_date: currentTeamMember.inactive_date
                            ? currentTeamMember.inactive_date
                            : null,
                        pre_emp_drug_test_date: currentTeamMember.pre_emp_drug_test_date
                            ? currentTeamMember.pre_emp_drug_test_date
                            : null,
                        pre_emp_mvr_date: currentTeamMember.pre_emp_mvr_date
                            ? currentTeamMember.pre_emp_mvr_date
                            : null,
                        default_vehicle: currentTeamMember.default_vehicle ? currentTeamMember.default_vehicle.id : null,
                        default_trailer: currentTeamMember.default_trailer ? currentTeamMember.default_trailer.id : null,
                        co_driver: this.co_driver,
                        pre_emp_clearing_house_date: currentTeamMember
                            .pre_emp_clearing_house_date
                            ? currentTeamMember.pre_emp_clearing_house_date
                            : null,
                        hazmat_date: currentTeamMember.hazmat_date
                            ? currentTeamMember.hazmat_date
                            : null,
                        insurance_date: currentTeamMember.insurance_date
                            ? currentTeamMember.insurance_date
                            : null,
                        license_date: currentTeamMember.license_date
                            ? currentTeamMember.license_date
                            : null,
                        medical_card_date: currentTeamMember.medical_card_date
                            ? currentTeamMember.medical_card_date
                            : null,
                        mvr_review_date: currentTeamMember.mvr_review_date
                            ? currentTeamMember.mvr_review_date
                            : null,
                        other_date: currentTeamMember.other_date
                            ? currentTeamMember.other_date
                            : null,
                        twic_card_date: currentTeamMember.twic_card_date
                            ? currentTeamMember.twic_card_date
                            : null,
                        lock_trailer: currentTeamMember.lock_trailer ? true : false,
                    };
                    await this.updateTeamMember({
                        id: teamMemberData.id,
                        payload: { ...teamMemberData, version: this.appVersion }
                    })
                    this.setUserData({ ...this.user, version: this.appVersion })
                    this.setAppVersion(this.appVersion)
                    this.$bvModal.hide('help-modal')
                }
                catch (e) {
                    console.log(e)
                }
            }
            else this.$bvModal.hide('help-modal')
        },
        async showSupportModal() {
            this.supportModal = true
            this.$bvModal.hide('help-modal')
            await this.$nextTick()
            this.$bvModal.show('support-modal')
        }
    },
}
</script>
<style scoped>
.update-notification-dot-2 {
    position: absolute;
    top: -8px;
    right: -8px;
}

.help-section {
    border: 1px solid #dee2e6;
    border-radius: 5px;
    height: 158px;
    width: 158px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
}

.help-section>p {
    font-weight: 500;
    color: black;
}

.help-section:hover {
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
}</style>